// extracted by mini-css-extract-plugin
export var appt = "styles-module--appt--338df";
export var confirm = "styles-module--confirm--9ef6b";
export var error = "styles-module--error--4031a";